export const toNumber = (v) => {
  if (v == null) return 0;
  if (typeof v === "number") return v;
  if (typeof v === "string") {
    const n = Number(
      v.replace(/[$,]/g, "").replace(/\s+/g, "").replace(/^-$/, "0")
    );
    return Number.isFinite(n) ? n : 0;
  }
  return 0;
};

export const fmtUSD = (n) =>
  new Intl.NumberFormat(undefined, {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  }).format(toNumber(n));

export const uniqueSorted = (arr) =>
  Array.from(new Set((arr || []).filter(Boolean))).sort((a, b) =>
    a.localeCompare(b)
  );
